import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'fromDicomName' })
export class FromDicomNamePipe implements PipeTransform {
  transform(value: string, isRef: Boolean, toArray: Boolean): any {
    let ind = 0;
    let name = "";
    let arr = (value) ? value.split('^') : null;
    if (toArray == true) {
      return arr;
    }
    if (isRef == true) {
      ind++;
    }
    name = arr[ind];
    ind++;
    name +=', ' + arr[ind];
    ind++;
    if (arr[ind]) {
      name += ' ' + arr[ind];
    }
    return name;
  }
}
